export class SessionExpiredError extends Error {
    constructor() {
        super("Your session has expired. Please sign in again.");
        this.name = "SessionExpiredError";
    }
}

export function requireAuthorizedResponse(response: Response, onUnauthorized: () => void): Response {
    if (response.status === 401) {
        onUnauthorized();
        // SessionValidator returns plain text. Never pass it to JSON-consuming callers.
        throw new SessionExpiredError();
    }

    return response;
}

export function shouldRetryQuery(failureCount: number, error: Error): boolean {
    return !(error instanceof SessionExpiredError) && failureCount < 1;
}
